import {
  AboutAPTCategories,
} from "../Data/AboutAPTData";
import {
  PersonalTrainingCategories,
  BusinessTrainingCategories
} from "../Data/CommunityCoursesData";
import {
  EmploymentSupportCategories,
} from "../Data/EmploymentSupportData";
import {
  CommunityProjectsCategories,
} from "../Data/CommunityProjectsData";
import {
  GetInvolvedCategories,
} from "../Data/GetInvolvedData";

// Navigation structure aligned with APT's Four Pillars:
// 1. Training
// 2. Employment Support (Local Employment Support)
// 3. Careers Advice (new dedicated section)
// 4. Advocacy (within Community Projects)

export const NavbarItems = [
  {
    title: "Home",
    url: "/",
    className: "nav-links",
    subnavitems: [],
  },

  {
    title: "About APT",
    url: "/about/mission-values",
    className: "nav-links",
    subnavitems: [
      {
        category: "Who We Are",
        categoryDescription:
          "Founded in 2013 by Emi Gjoni - serving East London communities",
        items: AboutAPTCategories.map((item) => ({
          title: item.title,
          url: item.url,
          className: "subnav-links",
        })),
      },
    ],
  },

  // PILLAR 4: Advocacy & Community Projects (Moved to front)
  {
    title: "Community Projects",
    url: "/community-projects",
    className: "nav-links",
    subnavitems: [
      {
        category: "Advocacy & Community Support",
        categoryDescription:
          "170+ advocacy cases, £45,000+ in benefits secured for clients",
        items: [
          {
            title: "Young People Coding & AI Camp",
            url: "/community-projects/ncil-youth-coding-camp",
            className: "subnav-links featured",
          },
          {
            title: "Women 4 Women",
            url: "/community-projects/women-4-women",
            className: "subnav-links featured",
          },
          {
            title: "Community Outreach",
            url: "/community-projects/community-outreach",
            className: "subnav-links featured",
          },
          ...CommunityProjectsCategories
            .filter((project) => project.id !== "women-4-women" && project.id !== "community-outreach")
            .map((project) => ({
              title: project.title,
              url: project.url,
              className: "subnav-links",
            })),
        ],
      },
    ],
  },

  // PILLAR 1: Training
  {
    title: "Training",
    url: "/training",
    className: "nav-links",
    subnavitems: [
      {
        category: "Personal Training",
        categoryDescription:
          "Professional qualifications and life skills for individuals",
        items: [
          ...PersonalTrainingCategories.map((course) => ({
            title: course.title,
            description: "",
            url: course.url,
            className: "subnav-links",
          })),
          {
            title: "View All Personal Training",
            url: "/training/personal",
            className: "subnav-links featured",
          }
        ],
      },
      {
        category: "Business Training",
        categoryDescription:
          "Bespoke training packages for organizations and teams",
        items: [
          ...BusinessTrainingCategories.map((course) => ({
            title: course.title,
            description: "",
            url: course.url,
            className: "subnav-links",
          })),
          {
            title: "View All Business Training",
            url: "/training/business",
            className: "subnav-links featured",
          }
        ],
      },
    ],
  },

  // PILLAR 2: Employment Support
  {
    title: "Employment Support",
    url: "/employment-support",
    className: "nav-links",
    subnavitems: [
      {
        category: "Your Path to Employment",
        categoryDescription:
          "45.7% job success rate - CV support, job search, interview prep",
        items: EmploymentSupportCategories.map((service) => ({
          title: service.title,
          url: service.url,
          className: "subnav-links",
        })),
      },
    ],
  },

  {
    title: "Get Involved",
    url: "/get-involved",
    className: "nav-links",
    subnavitems: [
      {
        category: "Join Our Community",
        categoryDescription:
          "Access free services, volunteer, or partner with us across East London",
        items: GetInvolvedCategories.map((item) => ({
          title: item.title,
          url: item.url,
          className: "subnav-links",
        })),
      },
    ],
  },
];
